/**
 * Append Parameters
 * 
 * allows you to append query parameters from the URL to link outs within the page
 */
define('components/append-params',[
    'jquery',
    'logging',
    'utilities',
    'application'
], function($, logging, utilities, app) {
    'use strict';

    var _ModuleName = "Append Params";
    var _config = {
        tags: ["a", "button"],
        attributes: ["src", "href"],
        params: []
    }

    /**
     * Init function is run imediatly, so DOM is not necessarily available.
     * This can be used for getting things ready such as config storage and such
     * @param {object} config Configuration object with data parameters passed in
     */
    var init = function(config) {
        _config.tags = config.appendParams.tags || _config.tags;
        _config.attributes = config.appendParams.attributes || _config.attributes;
        _config.params = config.appendParams.params || _config.params;
    }

    /**
     * Run function on only run after the DOM is ready
     * This can be used for any DOM manipulation code that needs to run
     */
    var run = function() {
        if (_config.tags.length && _config.params.length) {
            var $scope = $('.lp-pom-root');

            // make sure we have our scope
            if ($scope.length === 0) { return; }

            logging.debug("Appending Parameters to link outs per configuration", _ModuleName);

            // loop through the tags
            _config.tags.forEach(function(tag) {
                $(tag, $scope).toArray().forEach(function(elem) {
                    // update each HTML element
                    _config.params.forEach(function(param) {
                        // if array passed in for param, map from param[0] to param[1]
                        if (Array.isArray(param) && param.length == 2) {
                            // if param[0] is "od:email", we need to get lead data from frame config and use email as value
                            if (param[0] === "od:email") {
                                var leadData = app.getLeadData();
                                if (leadData && leadData.email) {
                                    _appendParameter(elem, param[1], leadData.email);
                                }
                            } 
                            
                            // otherwise, get the value from the URL
                            else {
                                var value = utilities.getParameter(document.URL, param[0]);
                                if (value) {
                                    _appendParameter(elem, param[1], value);
                                }   
                            }
                        } else {
                            // if param is "od:email", we need to get lead data from frame config and use email as value
                            if (param === "od:email") {
                                var leadData = app.getLeadData();
                                if (leadData && leadData.email) {
                                    _appendParameter(elem, param.replace('od:', ''), leadData.email);
                                }
                            }

                            // otherwise, get the value from the URL
                            else {
                                var value = utilities.getParameter(document.URL, param);
                                if (value) {
                                    _appendParameter(elem, param, value);
                                }
                            }
                        }
                    })
                })
            })
        }
    }

    var _appendParameter = function(elem, param, value) {

        _config.attributes.forEach(function(attr) {
            if (elem.hasAttribute(attr)) {
                var url = elem.getAttribute(attr);
                elem.setAttribute(attr, _getUpdatedUrl(url, param, value));
            }
        })
    }

    var _getUpdatedUrl = function(url, param, val) {
        var key = encodeURIComponent(param);
        var value = encodeURIComponent(val);

        if (url.indexOf('?') > -1) {
            // need to add to current list of query parameters
            var parts = url.split('?');
            var domainAndPath = parts[0];
            var queryParams = parts[1];

            var kvp = queryParams.split('&');
            var i = 0;

            // update if it already exists
            for (; i < kvp.length; i++) {
                if (kvp[i].startsWith(key + '=')) {
                    var pair = kvp[i].split('=');
                    pair[1] = value;
                    kvp[i] = pair.join('=');
                    break;
                }
            }

            // if no updates made, add new param
            if (i >= kvp.length) {
                kvp[kvp.length] = [key, value].join('=');
            }

            // return new url
            return domainAndPath + '?' + kvp.join('&');
        } else {
            // starting a new list of query parameters
            return url + '?' + key + '=' + value;
        }
    }

    return {
        init: init,
        run: run
    }
});
